/* Fixed enums for the Stage Config Templates API (not fetched — no listing endpoint
   for these). Labels match what the API itself sends back on a stage record's
   colour/stage_type/entry_access/exit_access ({ id, label }), e.g. "any" ->
   "Any (Lead or Admin)". */

export const STAGE_COLOUR_OPTIONS = [
  { value: 'blue', label: 'Blue' },
  { value: 'green', label: 'Green' },
  { value: 'orange', label: 'Orange' },
  { value: 'purple', label: 'Purple' },
  { value: 'red', label: 'Red' },
  { value: 'grey', label: 'Grey' },
];

export const STAGE_TYPE_OPTIONS = [
  { value: 'standard', label: 'Standard' },
  { value: 'start', label: 'Start' },
  { value: 'final', label: 'Final' },
  { value: 'exception', label: 'Exception' },
];

export const STAGE_ACCESS_OPTIONS = [
  { value: 'any', label: 'Any (Lead or Admin)' },
  { value: 'admin_only', label: 'Admin Only' },
  { value: 'system_automated', label: 'System Automated' },
];

/* Transition configuration enums, per the transition-engine documentation
   (not fetched — the API doesn't expose a listing endpoint for these). */

export const ALLOWED_ROLE_OPTIONS = ['Admin', 'Project Lead', 'TAM Rep', 'Client User'];

export const GUARD_TYPE_OPTIONS = [
  { id: 'field_check', label: 'Field Check' },
  { id: 'asset_count', label: 'Asset Count' },
  { id: 'rep_assigned', label: 'Rep Assigned' },
  { id: 'lead_assigned', label: 'Lead Assigned' },
];

export const FIELD_CHECK_FIELD_OPTIONS = [
  { id: 'report_status_records', label: 'Report Status (Records)' },
  { id: 'report_status_physical', label: 'Report Status (Physical)' },
  { id: 'report_submission_date', label: 'Report Submission Date' },
  { id: 'client_acceptance_date', label: 'Client Acceptance Date' },
  { id: 'invoice_status', label: 'Invoice Status' },
  { id: 'location', label: 'Location' },
  { id: 'lessee_id', label: 'Lessee' },
  { id: 'planned_start_date', label: 'Planned Start Date' },
  { id: 'planned_end_date', label: 'Planned End Date' },
];

export const FIELD_CHECK_OPERATOR_OPTIONS = [
  { id: 'eq', label: 'Equals' },
  { id: 'neq', label: 'Not Equals' },
  { id: 'gte', label: 'Greater Than or Equal' },
  { id: 'lte', label: 'Less Than or Equal' },
  { id: 'is_set', label: 'Is Set' },
  { id: 'is_not_set', label: 'Is Not Set' },
];

export const FIELD_CHECK_OPERATORS_BY_VALUE_TYPE = {
  date: ['eq', 'neq', 'gte', 'lte'],
  select: ['eq', 'neq'],
  'select-async': ['eq', 'neq'],
  text: ['eq', 'neq'],
};

export const NO_VALUE_OPERATORS = ['is_set', 'is_not_set'];

export const SET_FIELD_OPTIONS = FIELD_CHECK_FIELD_OPTIONS;

/* Matches the plain string list in program_planner/components/PlanDetailDialog.js
   (INVOICE_STATUSES), reshaped to { id, label } for use as an OptionField source. */
export const INVOICE_STATUS_OPTIONS = [
  { id: 'Not Raised', label: 'Not Raised' },
  { id: 'Raised', label: 'Raised' },
  { id: 'Paid', label: 'Paid' },
  { id: 'Financially Closed', label: 'Financially Closed' },
];

export const SET_FIELD_VALUE_TYPE = {
  report_status_records: 'select',
  report_status_physical: 'select',
  invoice_status: 'select',
  lessee_id: 'select-async',
  report_submission_date: 'date',
  client_acceptance_date: 'date',
  planned_start_date: 'date',
  planned_end_date: 'date',
  location: 'text',
};

export const ACTION_TYPE_OPTIONS = [
  { id: 'send_notification', label: 'Send Notification' },
  { id: 'set_field', label: 'Set Field' },
  { id: 'reset_inactivity_timer', label: 'Reset Inactivity Timer' },
];

export const NOTIFICATION_RECIPIENT_OPTIONS = [
  { id: 'plan_reps', label: 'Plan Reps' },
  { id: 'lead', label: 'Lead' },
];
